import {getJSON, postData} from "./API";
import {apiClient, getRequest, postRequest} from "./AxiosConfig";

export async function getImages(page, setErrorMessage){
    return await getRequest( `/media/images/all/${page}`, setErrorMessage);
}

export async function updateImage(image, setErrorMessage){
    return await postRequest( "/media/images/edit", setErrorMessage, image);
}
